/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Targetraise1Inputs */

const en_common_targetraise1 = /** @type {(inputs: Common_Targetraise1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Target Raise`)
};

/**
* | output |
* | --- |
* | "Target Raise" |
*
* @param {Common_Targetraise1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const common_targetraise1 = /** @type {((inputs?: Common_Targetraise1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Targetraise1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_common_targetraise1(inputs)
});
export { common_targetraise1 as "common_targetRaise" }